var map = {
	"./onboarding-step-1.png": "742c",
	"./onboarding-step-2.png": "466d",
	"./onboarding-step-3.png": "413e",
	"./onboarding-step-4.png": "dafa",
	"./onboarding-step-5.png": "2a8f",
	"./onboarding-step-6.png": "409f",
	"./onboarding-step-7-ir.png": "a3eb",
	"./onboarding-step-7.png": "a094",
	"./onboarding-step-8.png": "f296",
	"./onboarding-step-9.png": "f22f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0224";